export const defaultCreateData = {
  nodes: [
    {
      id: 71,
      label: "ریاضیات پایه",
      unit: 3,
      x: -747,
      y: -148,
      related: [72],
    },
    {
      id: 72,
      label: "ریاضیات عمومی 1",
      unit: 3,
      x: -747,
      y: 24,
      related: [73],
      prerequisite: [71],
    },
    {
      id: 73,
      label: "ریاضیات گسسته",
      unit: 3,
      x: -428,
      y: 170,
      related: [74, 75, 76],
      prerequisite: [{ coRequisite: 72 }],
    },
    {
      id: 74,
      label: "مدار منطقی",
      unit: 3,
      x: -240,
      y: 370,
      prerequisite: [73],
    },
    {
      id: 75,
      label: "ساختمان داده",
      unit: 3,
      x: -429,
      y: 370,
      prerequisite: [73],
    },
    {
      id: 76,
      label: "تحلیل و طراحی سیستم ها",
      unit: 3,
      x: -667,
      y: 370,
      prerequisite: [73],
    },
    {
      id: "d2",
      group: "dummies",
      x: -428,
      y: 24,
    },
    {
      id: "d3",
      group: "mainDummies",
      x: -428,
      y: 267,
    },
  ],
  edges: [
    { from: 71, to: 72 },
    { from: 72, to: "d2", dashes: true },
    { from: "d2", to: 73, dashes: true },
    { from: "73", to: "d3" },
    { from: "d3", to: "74" },
    { from: "d3", to: "75" },
    { from: "d3", to: "76" },
  ],
};
export const downloadData = (privateData) => {
  // Retrieve data from local storage
  const selections = JSON.parse(localStorage.getItem("selections"));
  const user = JSON.parse(localStorage.getItem("user"));
  const failedLessons = JSON.parse(localStorage.getItem("failedLessons"));
  const createDetail = JSON.parse(localStorage.getItem("createDetail"));
  const language = JSON.parse(localStorage.getItem("language"));

  // Create a Blob object from the combined data
  if (privateData) {
    user.name = "user";
    user.profile = null;
  }
  const dataBlob = new Blob(
    [
      JSON.stringify({
        selections: selections,
        user: user,
        failedLessons: failedLessons,
        createDetail: createDetail,
        language: language,
      }),
    ],
    { type: "application/json" }
  );

  // Create a temporary link with the Blob object as the href and the download attribute set
  const downloadLink = document.createElement("a");
  downloadLink.href = URL.createObjectURL(dataBlob);
  downloadLink.download = "DynamicChart(@jozveiau).json";

  // Click the link to start the download
  downloadLink.click();

  // Clean up the URL object
  URL.revokeObjectURL(downloadLink.href);
};
export const resetLocalStorage = (setGlobalState) => {
  let user = {
    name: "user",
    semester: "semester1",
    focus: false,
    mark: { state: false, selections: {} },
    edit: { state: false, positions: null, deletedNodes: {} },
    create: false,
    profile: null,
    optimization: "medium",
    guide: true,
  };
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("selections", JSON.stringify({ 1: "semester1" }));
  localStorage.setItem("failedLessons", JSON.stringify({}));
  localStorage.setItem("createDetail", JSON.stringify(defaultCreateData));

  if (setGlobalState) setGlobalState(user);
  else return user;
};
